import * as amplitude from "@amplitude/analytics-browser";
import { Box, Button, Icon, Tooltip } from "@chakra-ui/react";
import { RiHistoryLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import { useOrganization } from "src/hooks/useOrganization";
import * as Url from "src/services/url";
import { useUnreadFormActivities } from "./useUnreadFormActivities";

type Props = {
  formTemplateId: string;
};

export const ActivityButton = ({ formTemplateId }: Props) => {
  const organization = useOrganization();
  const hasUnread = useUnreadFormActivities(formTemplateId);
  const label = hasUnread ? "New activity" : "Activity";

  return (
    <Tooltip hasArrow placement="left" label={label}>
      <Button
        as={Link}
        to={organization
          .map((org) =>
            Url.OrgAdmin.Forms.activity({
              organization: org,
              formTemplateId,
            })
          )
          .withDefault("#")}
        variant="ghost"
        colorScheme="primary"
        aria-label={label}
        position="relative"
        onClick={() => {
          amplitude.track("Clicked bulk activity", {
            source: "button",
            has_unread: hasUnread,
          });
        }}
      >
        <Icon as={RiHistoryLine} />
        {hasUnread && (
          <Box
            position="absolute"
            top="2"
            right="2"
            boxSize="2"
            bg="red.500"
            borderRadius="full"
            aria-hidden
          />
        )}
      </Button>
    </Tooltip>
  );
};
